import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';
import * as ModalActions from '../../../stores/actions/modal';
import { DeleteSegment } from '../../../connection/segments';
import { showAlert } from '../../general-components/alert-service';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';

export default function DeleteSegmentConfirmation() {
	const dispatch = useDispatch();
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
	const modalData = useSelector((state: GreenroomState) => state.ModalReducer.modalData);

	const { segmentId } = modalData;
	const [isDeleting, setIsDeleting] = useState(false);

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	const deleteSegment = async () => {
		if (!meeting) return;
		setIsDeleting(true);
		const result = await DeleteSegment(meeting.meeting, segmentId);
		if (result === null) {
			showAlert({
				message: 'Failed to delete segment',
				description: 'Please try again',
				duration: 5000,
				type: 'error',
			});
			setIsDeleting(false);
			return;
		}
		closeModal();
	};

	return (
		<MultiButtonConfirmationModal
			className="delete-segment"
			headerText="Do you want to delete this segment?"
			bodyText="This action cannot be undone"
			firstButtonText="Cancel"
			secondButtonText="Delete"
			firstButtonAction={closeModal}
			secondButtonAction={deleteSegment}
			secondButtonDisabled={isDeleting}
			isOpen
		/>
	);
}
